export default "__VITE_PUBLIC_ASSET__8c0e94d8__"